import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=0f7418f8&"
import script from "./Past.vue?vue&type=script&lang=js&"
export * from "./Past.vue?vue&type=script&lang=js&"
import style0 from "./Past.vue?vue&type=style&index=0&id=0f7418f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports